import React from "react";
import { TextField, Button, Box } from "@mui/material";

const convertToSentenceCase = (str) => {
  return str
    .replace(/_/g, " ")
    .replace(/(?:^|\s)\S/g, (match) => match.toUpperCase());
};

const ArgumentField = ({ arg, value, onInputChange, onFileChange }) => {
  const isImage = arg.toLowerCase().includes("image");

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}
    >
      <label style={{ fontWeight: "bold", width: "150px", fontSize: "1rem" }}>
        {convertToSentenceCase(arg)}
      </label>

      {isImage ? (
        <Button
          variant="contained"
          component="label"
          sx={{
            textTransform: "none",
            padding: "8px 16px",
            minWidth: "165px",
          }}
        >
          Upload Image
          <input
            type="file"
            accept="image/*"
            hidden
            onChange={(e) => onFileChange(arg, e.target.files[0])}
          />
        </Button>
      ) : (
        <TextField
          label={convertToSentenceCase(arg)}
          variant="outlined"
          size="small"
          margin="dense"
          value={value || ""}
          onChange={(e) => onInputChange(arg, e.target.value)}
          placeholder={
            ["event_name", "host_name"].includes(arg) ? "Autofilled" : ""
          }
          disabled={["event_name", "host_name"].includes(arg)}
          sx={{
            minWidth: "150px",
            "& .MuiInputLabel-root": {
              fontSize: "1rem",
            },
            "& .MuiOutlinedInput-root": {
              minHeight: "40px",
            },
          }}
        />
      )}
    </Box>
  );
};

export default ArgumentField;
